__turbopack_context__.v({
  "loader": "XXi5Pq_loader",
  "rotate": "XXi5Pq_rotate",
});
